import { useCallback, useState } from "react"
import {
   getPersistedCollapsedLocationIds,
   persistCollapsedLocationIds,
} from "../utils"

export const useCollapsedLocation = (locationId: string) => {
   const [isCollapsed, setIsCollapsed] = useState(() =>
      getPersistedCollapsedLocationIds().includes(locationId)
   )

   const toggleCollapsed = useCallback(() => {
      setIsCollapsed((prev) => {
         const next = !prev
         const collapsedLocationIds = getPersistedCollapsedLocationIds()
         persistCollapsedLocationIds(
            next
               ? [...collapsedLocationIds, locationId]
               : collapsedLocationIds.filter((id) => id !== locationId)
         )
         return next
      })
   }, [locationId])

   return { isCollapsed, toggleCollapsed }
}
